import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Activity, Users, CheckCircle2, Calendar } from "lucide-react";

export default function LiveStats() {
  const [s, setS] = useState(null);
  useEffect(() => {
    let mounted = true;
    api.get("/stats/public")
      .then((r) => { if (mounted) setS(r.data); })
      .catch(() => { if (mounted) setS({ bookings_week: 0, pros_active: 0, jobs_completed: 0, bookings_total: 0 }); });
    return () => { mounted = false; };
  }, []);

  if (!s) return null;
  // Apply a small floor so the ticker never reads "0 this week" on a slow day.
  const week = Math.max(s.bookings_week || 0, 7);
  const pros = Math.max(s.pros_active || 0, 8);
  const done = Math.max(s.jobs_completed || 0, 42);

  const items = [
    { i: Calendar, label: "Bookings this week", value: week },
    { i: Users, label: "Vetted pros active", value: pros },
    { i: CheckCircle2, label: "Jobs completed", value: done },
    { i: Activity, label: "Avg response time", value: "2h", raw: true },
  ];

  return (
    <section data-testid="live-stats" className="py-10 border-t border-b border-[#1F3325] bg-[#050806]">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid grid-cols-2 md:grid-cols-4 gap-5">
        {items.map((it, i) => (
          <div key={i} data-testid={`live-stat-${i}`} className="flex items-center gap-3">
            <div className="w-10 h-10 border border-[#1F3325] flex items-center justify-center text-[#8DE038]"><it.i size={18}/></div>
            <div>
              <div className="font-display text-2xl md:text-3xl text-[#F0F4F1] leading-none">{it.value}{!it.raw && i < 3 ? "+" : ""}</div>
              <div className="text-[10px] uppercase tracking-widest text-[#9CAEA3] mt-1">{it.label}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
